import React from "react";
import styled from "@emotion/styled";

import BButton from "@components/BButton/BButton";

interface ProductBoxProps {
  goalName: string
}

const goalNameToString = new Map([
  ['brain-fog', 'Brain Fog'],
  ['heart-health', 'Heart Health'],
  ['anxiety-and-depression', 'Anxiety and Depression'],
  ['fatigue', 'Fatigue'],
  ['weight-management', 'Weight Management']
])
const ProductBox: React.FC<ProductBoxProps> = ({ goalName }) => {
  const goal = goalNameToString.get(goalName)
  return (
    <ProductBoxContainer>
      <ProductBoxImage src={`https://statics.get-base.com/blog/products/product_box_${goalName}.webp`}/>
      <ProductBoxBodyContainer>
        <ProductBoxTitle>
          Need help with { goal.toLowerCase() }?
        </ProductBoxTitle>
        <ProductBoxBody>
          Learn about the hormone and nutrient imbalances that could be affecting your { goal.toLowerCase() }.
        </ProductBoxBody>
        <BButton href="/quiz" text="TAKE QUIZ" dark={true} />
        <ProductBoxCaptionContainer>
          <ProductBoxCaption href="/all-goals">
            Browse all tests
          </ProductBoxCaption>
        </ProductBoxCaptionContainer>
      </ProductBoxBodyContainer>
    </ProductBoxContainer>
  );
};

const ProductBoxContainer = styled.div`
  z-index: 10;
  border: 1px solid #000000;
  background-color: #ffffff;
`;

const ProductBoxBodyContainer = styled.div`
  padding: 16px;
`;


const ProductBoxImage = styled.img`
  width: 100%;
  border-bottom: 1px solid #000000;
`;

const ProductBoxCaption = styled.a`
  color: #000000;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-decoration: underline;
  text-align: center;
`;

const ProductBoxCaptionContainer = styled.div`
  padding-top: 16px;
  text-align: center;
`;

const ProductBoxTitle = styled.div`
  font-size: 24px;
  line-height: 26px;
  letter-spacing: -0.02em;
  padding-bottom: 16px;
`;

const ProductBoxBody = styled.div`
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.01em;
  padding-bottom: 40px;
`;

export default ProductBox;
